exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".conference--topic {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 80px; }\n  .conference--topic .topic--title {\n    background: url(" + require("../../../images/topic-title.png") + ") no-repeat center;\n    width: 226px;\n    height: 80px;\n    font-size: 30px;\n    text-align: center;\n    line-height: 80px;\n    margin-bottom: 94px; }\n  .conference--topic .topic--body {\n    width: 1180px;\n    display: flex;\n    flex-direction: column;\n    align-items: center; }\n    .conference--topic .topic--body .topic--row {\n      display: flex;\n      width: 1180px;\n      flex-direction: row;\n      margin-bottom: 70px; }\n      .conference--topic .topic--body .topic--row .topic--item {\n        margin-right: 30px; }\n      .conference--topic .topic--body .topic--row .topic--item:last-child {\n        margin-right: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/pages/home/topics/index.scss
// module id = 645
// module chunks = 0